import {
  Alert,
  Button,
  Classes,
  Dialog,
  FormGroup,
  H5,
  HTMLTable,
  InputGroup,
  Popover,
  Switch,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import {
  MDBBtn,
  MDBCol,
  MDBModalBody,
  MDBRow,
} from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { IViewModel } from "mobx-utils";
import * as moment from "moment";
import * as React from "react";
import { api } from "../../api";
import {
  IContador,
  IPlanoUpdate,
  IUsuario,
  newIContador,
  newUpdatePlano,
} from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { ContadorDialogStore } from "../../stores/perfil/ContadorDialogStore";
import { PerfilStore } from "../../stores/perfil/PerfilStore";
import { toast } from "react-toastify";
import CalculadoraPage from "../calculadora/Calculadora";
import CertificadoDialog from "./CertificadoDialog";
import { ChangeImageDialog } from "./ChangeImageDialog";
import { ChangePasswordDialog } from "./ChangePasswordDialog";
import { CreateContadorDialog } from "./CreateContadorDialog";
import { CreateUserDialog } from "./CreateUserDialog";
import DataVencimento from "./DataVencimentoPage";
import { EditUserDialog } from "./EditUserDialog";
import FormaPagamento from "./FormaPagamentoPage";
import { GeneratePage } from "../2fa/GeneratePage";
import { GenerateStore } from "../../stores/2fa/GenerateStore";
import InfoModal from "../info-modal/InfoModal";
import { AppIcon } from "../utils/AppIcon";
import PhoneNumberInput from "../utils/PhoneNumberInput";
import { formatCnpj } from "../../utils";

const numeral = require("numeral");
const InputMask = require("react-input-mask");

@observer
export default class PerfilPage extends React.Component<{}, {}> {
  obs = observable({
    changingPassword: false as boolean,
    changingImage: false as boolean,
    createUser: false as boolean,
    editUser: false as boolean,
    newPassword: "" as string,
    newEmail: "" as string,
    alterPassUser: false as boolean,
    alterEmailIugu: false as boolean,
    id_user: "" as string,
    user_edit: null as IUsuario & IViewModel<IUsuario>,
    planBasic: false as boolean,
    planEssencial: false as boolean,
    planFull: false as boolean,
    planBusiness: false as boolean,
    historico_plano: false as boolean,
    items_historico_plano: [] as any[],
    item_contador: {} as IContador,
    open_update_plano: false as boolean,
    update_plano: {} as IPlanoUpdate,
    planSefip: false as boolean,
    selectedTab: "forma_pagamento" as string,
    selectedTabContador: "create_contador" as string,
    trFormaPagamento: {} as React.RefObject<any>,
    trDataVencimento: {} as React.RefObject<any>,
    items_planos: [] as any,
    open_ajuda: false as boolean,
    max_number_dec_sefa_conta: 2 as number
  })

  constructor(props: {}) {
    super(props);
    AppStore.setTitle("Seu Perfil");

    this.obs.trFormaPagamento = React.createRef();
    this.obs.trDataVencimento = React.createRef();
  }

  componentDidMount() {
    ContadorDialogStore.handleGetContadores();

    PerfilStore.obs.plan_nome_completo = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.nome : "";
    PerfilStore.obs.plan_email = AppStore.obs1.usuario ? AppStore.obs1.usuario.email : "";
    PerfilStore.obs.plan_telefone = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.telefone : "";

    this.obs.item_contador = newIContador();
    this.obs.update_plano = newUpdatePlano();
  }

  handlePageChange = (page: number) => {
    PerfilStore.setCurrentPage(page);
  };

  handleAlterPass = (id: any) => {
    this.obs.id_user = id;
    this.obs.alterPassUser = true;
  };

  handleGoFinanceiro = () => {
    AppStore.setLocation("/historico-financeiro");
  };

  viewValores = () => {
    AppStore.setLocation("/alteracoes-plano");
  };

  handleCancelAlterPass = () => {
    this.obs.alterPassUser = false;
  };

  handleCancelAlterEmailIugu = () => {
    this.obs.alterEmailIugu = false;
  };

  handleCancelUserDominio = () => {
    PerfilStore.obs.user_dominio = ""
    PerfilStore.obs.password_dominio = ""
    PerfilStore.obs.open_user_dominio = false;
  };

  handleSendAlterPass = async () => {

    await PerfilStore.handleSendAlterPass(this.obs.id_user, this.obs.newPassword)

    this.obs.alterPassUser = false;

  };

  handleSendAlterEmailIugu = async () => {

    let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    if (!regex.test(this.obs.newEmail)) {
      toast.warning("E-mail inválido!", {});
      return
    }

    await PerfilStore.handleSendAlterEmailIugu(this.obs.newEmail)

    this.obs.alterEmailIugu = false;

  };

  refresh = () => {
    window.location.reload();
  };

  handleEdit = (usuario: any) => {
    PerfilStore.setUser(usuario);
    this.obs.editUser = true;
  };

  handleDeleteUsuario = async (id: any) => {

    try {

      let resp = await api.get(`/api/deleta-usuario/${id}`);

      if(resp.data.ok) {

        toast.success('Usuário Deletado com sucesso', {});

      } else {

        toast.error(resp.data.msg, {});

      }

    } catch (ex) {

      toast.error("Erro ao deletar o Usuário, tente novamente mais tarde.", {});

    } finally {

      setInterval(this.refresh, 1000);

    }

  };

  async handleDeleteContador(id: string) {
    await ContadorDialogStore.handleDeleteContador(id);

    if (ContadorDialogStore.obs.status_ok) {
      ContadorDialogStore.handleGetContadores();
      toast.success('Contador deletado com sucesso', {});
      window.location.reload();
    } else {
      toast.error('Não foi possível deletar o contador, tente novamente mais tarde', {});
    }
  }

  handleOpenLink(url: string) {
    window.open(url, '_blank');
  }

  handleOpenContadores() {
    this.obs.item_contador = newIContador();
    ContadorDialogStore.obs.isOpen_contador = true;
  }

  handleEditContador(item: IContador) {
    this.obs.item_contador = item;
    ContadorDialogStore.obs.isOpen_contador = true;
  }

  handleEditUserDominio(value: any) {
    PerfilStore.obs.user_dominio = value.user_dominio
    PerfilStore.obs.user_folha = value.user_folha
    PerfilStore.obs.open_user_dominio = true;
  }

  handleCreateUserDominio() {
    PerfilStore.obs.user_dominio = ""
    PerfilStore.obs.password_dominio = ""
    PerfilStore.obs.user_folha = ""
    PerfilStore.obs.password_folha = ""
    PerfilStore.obs.open_user_dominio = true;
  }

  async handleDeleteUserDominio() {
    PerfilStore.obs.user_dominio = ""
    PerfilStore.obs.password_dominio = ""
    PerfilStore.obs.user_folha = ""
    PerfilStore.obs.password_folha = ""
    await PerfilStore.handleSaveUserDominio()
  }

  async handleSaveUserDominio() {
    if (PerfilStore.obs.user_dominio == "") {
      toast.error('Usuário Domínio obrigatório', {});
      return
    }
    if (PerfilStore.obs.password_dominio == "") {
      toast.error('Senha Domínio obrigatória', {});
      return
    }
    if (PerfilStore.obs.user_folha == "") {
      toast.error('Usuário Folha obrigatório', {});
      return
    }
    if (PerfilStore.obs.password_folha == "") {
      toast.error('Senha Folha obrigatória', {});
      return
    }

    await PerfilStore.handleSaveUserDominio()
  }

  handleSetOff(cnpj: string) {

    EmpresaStore.obs.cnpj = cnpj
    EmpresaStore.obs.rendimento_mensal = 0

    EmpresaStore.obs.open_calculadora = true;

  }

  async handleUpdatePlano() {

    let data = {
      cnpj: EmpresaStore.obs.cnpj,
      plano: EmpresaStore.obs.plano
    }

    await PerfilStore.updateNextPlano(data);
  }


  onCloseSelectPlano() {
    EmpresaStore.obs.open_calculadora = false;
    EmpresaStore.obs.rendimento_mensal = 0
    EmpresaStore.obs.valorPlano = null
    EmpresaStore.obs.plano = []
  }

  async handleHistoricoPlano() {
    this.obs.items_historico_plano = PerfilStore.obs.historico_faturas?.map(plano => {
      return (
        <tr key={plano.id}>
          <td>{moment(plano.due_date).format("MM/YY")}</td>
          <td>{plano.total}</td>
          <td>
            <MDBBtn
              className="btnDefault"
              onClick={() => this.handleOpenLink(plano.secure_url)}
            >
              visualizar
            </MDBBtn>
          </td>
        </tr>
      );
    });

    this.obs.historico_plano = true;
  }

  handleRenderContaTab() {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "row" }} >
          <FormGroup label="Nome" labelFor="nome" style={{ marginRight: 20 }} >
            <InputGroup value={PerfilStore.obs.nome} onChange={(e: any) => PerfilStore.obs.nome = e.target.value} style={{ width: 400 }} />
          </FormGroup>

          <FormGroup label="CNPJ" labelFor="cnpj" style={{ marginRight: 20 }} >
            <InputMask mask="99.999.999/9999-99" className="form-control" value={PerfilStore.obs.cnpj} disabled={true} style={{ width: 250 }} />
          </FormGroup>
        </div>

        <div style={{ display: "flex", flexDirection: "row" }} >
          <FormGroup label="Rua" labelFor="rua" style={{ marginRight: 20 }} >
            <InputGroup value={PerfilStore.obs.rua} onChange={(e: any) => PerfilStore.obs.rua = e.target.value} style={{ width: 400 }} />
          </FormGroup>

          <FormGroup label="Bairro" labelFor="bairro" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.bairro} onChange={(e: any) => PerfilStore.obs.bairro = e.target.value} style={{ width: 250 }} />
          </FormGroup>

        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup label="Número" labelFor="numero" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.numero} onChange={(e: any) => PerfilStore.obs.numero = e.target.value} style={{ width: 70 }} />
          </FormGroup>

          <FormGroup label="Cidade" labelFor="cidade" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.cidade} onChange={(e: any) => PerfilStore.obs.cidade = e.target.value} style={{ width: 310 }} />
          </FormGroup>

          <FormGroup label="Estado" labelFor="estado" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.estado} onChange={(e: any) => PerfilStore.obs.estado = e.target.value} style={{ width: 60 }} />
          </FormGroup>

          <FormGroup label="CEP" labelFor="cep" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.cep} onChange={(e: any) => PerfilStore.obs.cep = e.target.value} style={{ width: 170 }} />
          </FormGroup>

        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup label="DDD" labelFor="ddd" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.ddd} onChange={(e: any) => PerfilStore.obs.ddd = e.target.value} style={{ width: 70 }} />
          </FormGroup>

          <FormGroup label="Telefone" labelFor="telefone" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.telefone} onChange={(e: any) => PerfilStore.obs.telefone = e.target.value} style={{ width: 310 }} />
          </FormGroup>
        </div>
      </>
    )
  }
  handldeRenderContratanteTab() {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup label="Nome Contratante" labelFor="nome_contratante" style={{ marginRight: 20 }} >
            <InputGroup value={PerfilStore.obs.nome_pessoa} onChange={(e: any) => PerfilStore.obs.nome_pessoa = e.target.value} style={{ width: 500 }} />
          </FormGroup>

          <FormGroup label="CPF Contratante" labelFor="cpf" style={{ marginRight: 20 }} >
            <InputMask mask="999.999.999-99" className="form-control" value={PerfilStore.obs.cpf_pessoa} onChange={(e: any) => PerfilStore.obs.cpf_pessoa = e.target.value} style={{ width: 200 }} />
          </FormGroup>
        </div>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup label="Rua Contratante" labelFor="rua_contratante" style={{ marginRight: 20 }} >
            <InputGroup value={PerfilStore.obs.rua_pessoa} onChange={(e: any) => PerfilStore.obs.rua_pessoa = e.target.value} style={{ width: 300 }} />
          </FormGroup>

          <FormGroup label="Bairro Contratante" labelFor="bairro_contratante" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.bairro_pessoa} onChange={(e: any) => PerfilStore.obs.bairro_pessoa = e.target.value} style={{ width: 180 }} />
          </FormGroup>

          <FormGroup label="Número Contratante" labelFor="numero_contratante" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.numero_pessoa} onChange={(e: any) => PerfilStore.obs.numero_pessoa = e.target.value} style={{ width: 200 }} />
          </FormGroup>
        </div>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup label="Cidade Contratante" labelFor="cidade_contratante" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.cidade_pessoa} onChange={(e: any) => PerfilStore.obs.cidade_pessoa = e.target.value} style={{ width: 300 }} />
          </FormGroup>

          <FormGroup label="CEP Contratante" labelFor="cep_contratante" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.cep_pessoa} onChange={(e: any) => PerfilStore.obs.cep_pessoa = e.target.value} style={{ width: 180 }} />
          </FormGroup>

          <FormGroup label="Estado Contratante" labelFor="estado_contratante" style={{ marginRight: 20 }}>
            <InputGroup value={PerfilStore.obs.estado_pessoa} onChange={(e: any) => PerfilStore.obs.estado_pessoa = e.target.value} style={{ width: 200 }} />
          </FormGroup>
        </div >
      </>
    )
  }

  handldeChargeTab(tabId) {
    PerfilStore.obs.change_tab_conta = tabId
  }

  async handldeContador() {

    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

    if (ContadorDialogStore.obs.contador.nome == "") {
      toast.warning('Preencha o nome', {});
      return;
    } else if (ContadorDialogStore.obs.contador.email == "") {
      toast.warning('Preencha o email', {});
      return;
    } else if (!regex.test(ContadorDialogStore.obs.contador.email)) {
      toast.warning('E-mail inválido', {});
      return;
    } else if (ContadorDialogStore.obs.contador.cpf == "") {
      toast.warning('Preencha o cpf', {});
      return;
    } else if (ContadorDialogStore.obs.contador.crc == "") {
      toast.warning('Preencha o crc', {});
      return;
    } else if (!ContadorDialogStore.obs.cep_is_valid) {
      toast.warning('Preencha um cep válido', {});
      return;
    }

    if (ContadorDialogStore.obs.is_edit) {

      await ContadorDialogStore.handlePutContador(ContadorDialogStore.obs.contador);

    } else {

      await ContadorDialogStore.handleCreateContador(ContadorDialogStore.obs.contador);

    }

  }

  handldeRenderMascaraTab() {
    return (
      <>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup label="Máscara contábil" labelFor="mascara_contabil" style={{ marginRight: 20 }} >
            <InputGroup value={PerfilStore.obs.mascara_contabil} onChange={(e: any) => PerfilStore.obs.mascara_contabil = e.target.value} style={{ width: 500 }} />
          </FormGroup>
        </div>

        <div style={{ display: "flex", flexDirection: "row" }}>
          <FormGroup label="Máscara para relatórios" labelFor="mascara_relatorios" style={{ marginRight: 20 }} >
            <InputGroup value={PerfilStore.obs.mascara_relatorios} onChange={(e: any) => PerfilStore.obs.mascara_relatorios = e.target.value} style={{ width: 300 }} />
          </FormGroup>
        </div>
      </>
    )
  }

  handleOpenAuth2Fa() {
    GenerateStore.obs.open_2fa = true
  }

  handleClose2Fa() {
    GenerateStore.obs.open_2fa = false
    GenerateStore.obs.codeBackup = []
  }

  handldeRenderDecSefa() {
    return (
      <>
        <Switch
          label="Receber aviso de NOVAS MENSAGENS por WhatsApp"
          alignIndicator="right"
          checked={PerfilStore.obs.dec_sefa_conta_message}
          onChange={(e: any) => PerfilStore.obs.dec_sefa_conta_message = e.target.checked}
          style={{ width: "max-content", fontWeight: "bold" }}
        />

        <br/>

        {PerfilStore.obs.dec_sefa_conta_message ? (<>

          <FormGroup helperText={`Pressione Enter a cada número informando para adicionar. Insira até ${this.obs.max_number_dec_sefa_conta} números com DDD para receber avisos de novas mensagens. Esse número será usado para todas as empresas.`}>
            <PhoneNumberInput
              value={typeof PerfilStore.obs.dec_sefa_conta_numero == "string" ? [PerfilStore.obs.dec_sefa_conta_numero] : PerfilStore.obs.dec_sefa_conta_numero}
              onChange={(phones) => PerfilStore.obs.dec_sefa_conta_numero = phones}
              maxPhones={this.obs.max_number_dec_sefa_conta}
              placeholder="+55 (11) 99999-9999"
              disabled={false}
            />
          </FormGroup>

        </>) : <br />}
      </>
    )
  }

  async handleAlterConta() {

    let dec_sefa_numeros: string[] = (PerfilStore.obs.dec_sefa_conta_numero || [])
    PerfilStore.obs.dec_sefa_conta_numero = dec_sefa_numeros;

    if (PerfilStore.obs.dec_sefa_conta_message && !dec_sefa_numeros.length) {
      toast.warning("Informe pelo menos um telefone para receber os avisos do DEC SEFA.", {});
      return
    }

    PerfilStore.obs.contaEdit = false

    await PerfilStore.alterar_conta()

    await PerfilStore.dadosConta()

  }

  renderData() {
    let contaPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    let userPrincipal = AppStore.obs1.usuario ? AppStore.obs1.usuario.principal : false;
    let userId = AppStore.obs1.usuario ? AppStore.obs1.usuario.id : "";
    let niveis_acesso = false

    if (AppStore.obs1.usuario) {
      if (userPrincipal) {
        niveis_acesso = true

      } else {
        niveis_acesso = AppStore.obs1.usuario.niveis_acesso?.indexOf("p1") != -1
      }
    }

    let rows = PerfilStore.obs.usuarios?.map(usu => {
      return (
        <tr key={usu.id}>
          <td>{usu.nome_completo}</td>
          <td>{usu.email}</td>
          <td>
            **********
            <MDBBtn onClick={() => this.handleAlterPass(usu.id)}>
              <img
                className="imgIconsEdit"
                src="/images/edit-user.svg"
                width="18px;"
              />
            </MDBBtn>
          </td>
          <td>
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEdit.bind(this, usu)}
            >
              <img
                className="imgIconsEditca"
                src="/images/edit.png"
                width={18}
              />
            </MDBBtn>

            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn disabled={userId == usu.id}>
                <img
                  className="imgIconsTrash"
                  src="/images/bin.png"
                  width="18px;"
                />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={() => this.handleDeleteUsuario(usu.id)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
          <td>
            {usu.principal &&
              <img
                src="/images/user.svg"
                style={{ marginTop: 10 }}
                width={20}
              />
            }
          </td>

        </tr>
      );
    });

    let rows_contador = ContadorDialogStore.obs.contadores_list?.map(usu => {
      return (
        <tr key={usu.id}>
          <td>{usu.nome}</td>
          <td>{usu.email}</td>
          <td>
            {usu.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")}
          </td>
          <td>{usu.crc}</td>
          <td>{usu.cep.replace(/(\d{5})(\d{3})/, "$1-$2")}</td>
          <td>
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEditContador.bind(this, usu)}
            >
              <img
                className="imgIconsEditca"
                src="/images/edit.png"
                width={18}
              />
            </MDBBtn>

            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn disabled={userId == usu.id}>
                <img
                  className="imgIconsTrash"
                  src="/images/bin.png"
                  width="18px;"
                />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={() => this.handleDeleteContador(usu.id)}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      );
    });

    const planBasic = (empresas, faixa) => {

      this.obs.items_planos = { empresas: empresas, faixa: faixa }

      this.obs.planBasic = true
    }

    const itens = Object.keys(PerfilStore.obs.empresas_planos)
      .map((faixa) => parseInt(faixa.match(/\d+/)[0]))
      .sort((a, b) => {
        if (a === 0) return -1;
        if (b === 0) return 1;
        return a - b;
      })
      .map((faixa) => {
        const empresasNessaFaixa = PerfilStore.obs.empresas_planos[`faixa${faixa}`];

        let valor = empresasNessaFaixa[0].plano.valor
        let armazenamento = (empresasNessaFaixa[0].plano.armazenamento) * 1000000
        let maximo = empresasNessaFaixa[0].plano.maximo

        if (faixa == 0) {
          return (<>
            <MDBCol md="6" key={faixa}>
              <div className="blocoAssin">
                <span className="descAssinPerfil">Plano <b>SEFIP</b></span>
                <span className="priceAssinPerfil"><b>R$</b> 14,90</span>
                <span className="periodoAssinPerfil">/ mês</span>
                <span className="descAssinPerfil"></span>
                <br />
                <br />
                <span
                  className="countAssinPerfil"
                  onClick={() => planBasic(empresasNessaFaixa, faixa)}
                >
                  {empresasNessaFaixa.length <= 1
                    ? empresasNessaFaixa.length + " CNPJ"
                    : empresasNessaFaixa.length + " CNPJs"}
                </span>
              </div>
            </MDBCol>
          </>)
        }

        return (
          <MDBCol md="6" key={faixa}>
            <div className="blocoAssin">
              <span className="descAssinPerfil">{faixa}ª Faixa</span>
              <span className="priceAssinPerfil"><b>R$</b> {numeral(valor).format("0,0.00")}</span>
              <span className="periodoAssinPerfil">por empresa (mensal)</span>
              <span className="descAssinPerfil">
                Até {numeral(maximo).format("$ 0,0.00")} de valor calculado <br />
                {`${numeral(armazenamento).format('0 b')} de armazenamento`} <br />{" "}
              </span>
              <span
                className="countAssinPerfil"
                onClick={() => planBasic(empresasNessaFaixa, faixa)}
              >
                {empresasNessaFaixa.length <= 1
                  ? empresasNessaFaixa.length + " CNPJ"
                  : empresasNessaFaixa.length + " CNPJs"}
              </span>
            </div>
          </MDBCol>
        );
      });

    let items_personalizados = PerfilStore.obs.empresas_planos_personalizados?.map(emp => {

      return (
        <tr key={emp.cnpj}>
          <td>{emp.razao_social}</td>
          <td>
            {emp.cnpj.replace(
              /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
              "$1.$2.$3/$4-$5",
            )}
          </td>
          <td>{"R$ " + numeral(emp.valor_calculado).format("0,0.00")}</td>
          <td>{"R$ " + numeral(emp.plano.valor).format("0,0.00")}</td>
        </tr>
      );
    });

    let rows_user_dominio = PerfilStore.obs.users_dominio?.map(value => {
      return (
        <tr>
          <td>{value.user_dominio}</td>
          <td>**********</td>
          <td>{value.user_folha}</td>
          <td>**********</td>
          <td>
            <MDBBtn
              color="default"
              rounded
              size="sm"
              onClick={this.handleEditUserDominio.bind(this, value)}
            >
              <img
                className="imgIconsEditca"
                src="/images/edit.png"
                width={18}
              />
            </MDBBtn>

            <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
              <MDBBtn>
                <img
                  className="imgIconsTrash"
                  src="/images/bin.png"
                  width="18px;"
                />
              </MDBBtn>
              <div>
                <H5>Confirmar exclusão?</H5>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 15,
                  }}
                >
                  <Button
                    className={Classes.POPOVER_DISMISS}
                    style={{ marginRight: 10 }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    intent="danger"
                    className={Classes.POPOVER_DISMISS}
                    onClick={() => this.handleDeleteUserDominio()}
                  >
                    Excluir
                  </Button>
                </div>
              </div>
            </Popover>
          </td>
        </tr>
      )
    })

    return (
      <div className="empresas-page">

        <Dialog
          isOpen={GenerateStore.obs.open_2fa}
          onClose={() => this.handleClose2Fa()}
          className="modal-two-factor">

          <div className={Classes.DIALOG_CLOSE_BUTTON}>

            <AppIcon name="close" color="#000" style={{ float: "right", cursor: "pointer" }} onClick={() => this.handleClose2Fa()} />

          </div>

          <GeneratePage />

        </Dialog>

        {AppStore.obs1.usuario &&
          (
            <>
              <Dialog
                isOpen={PerfilStore.obs.contaEdit}
                title="Editar Dados"
                onClose={() => PerfilStore.obs.contaEdit = false}
                style={{ width: 600 }}
              >

                <div>
                  <Tabs
                    id="tabs"
                    className="tabs-edit-conta"
                    selectedTabId={PerfilStore.obs.change_tab_conta}
                    onChange={(tabId) => this.handldeChargeTab(tabId)}
                  >
                    <Tab id="conta" title="Conta" panel={this.handleRenderContaTab()} />
                    <Tab id="contratante" title="Contratante" panel={this.handldeRenderContratanteTab()} />
                    <Tab id="mascara" title="Máscaras" panel={this.handldeRenderMascaraTab()} />
                    <Tab id="dec_sefa" title="Dec Sefa" panel={this.handldeRenderDecSefa()} />
                  </Tabs>
                </div>

                <div className={Classes.DIALOG_FOOTER}>
                  <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button text="Cancelar" onClick={() => PerfilStore.obs.contaEdit = false} />
                    <Button text="Salvar" intent="primary" onClick={() => this.handleAlterConta()} />
                  </div>
                </div>
              </Dialog>

              <Dialog
                isOpen={this.obs.planBasic}
                title="Plano"
                onClose={() => this.obs.planBasic = false}
              >
                <MDBModalBody style={{ height: 520, overflow: "auto" }}>
                  <div className={Classes.DIALOG_BODY}>
                    <div className="emp-plans">
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "50%" }}>Empresa</th>
                            <th>CNPJ</th>
                            <th>Calculado ({moment().format("MM/YY")})</th>
                            <th>Valor</th>
                            {this.obs.items_planos.faixa == 0 && <th/>}
                          </tr>
                        </thead>
                        <tbody>
                          {this.obs.items_planos.empresas?.map(emp => {
                            return (<tr key={emp.cnpj}>
                              <td>{emp.razao_social}</td>
                              <td>{emp.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")}</td>
                              <td>{"R$ " + numeral(emp.valor_calculado).format("0,0.00")}</td>
                              <td>{"R$ " + numeral(emp.plano.valor).format("0,0.00")}</td>
                              {this.obs.items_planos.faixa == 0 &&
                                <td><span className="btn_plano" onClick={() => this.handleSetOff(emp.cnpj)}>alterar</span></td>
                              }
                            </tr>)
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </MDBModalBody>
              </Dialog>

              <Dialog
                isOpen={this.obs.planBusiness}
                title="Plano Personalizado"
                onClose={() => this.obs.planBusiness = false}
              >
                <MDBModalBody style={{ height: 520, overflow: "auto" }}>
                  <div className={Classes.DIALOG_BODY}>
                    <div className="emp-plans">
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "50%" }}>Empresa</th>
                            <th>CNPJ</th>
                            <th>Calculado ({moment().format("MM/YY")})</th>
                            <th>Valor</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items_personalizados}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </MDBModalBody>
              </Dialog>

              <Dialog
                isOpen={this.obs.historico_plano}
                title="Histórico Plano"
                onClose={() => this.obs.historico_plano = false}
              >
                <MDBModalBody style={{ height: 520, overflow: "auto" }}>
                  <div className={Classes.DIALOG_BODY}>
                    <div className="emp-plans">
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th style={{ width: "50%" }}>Data</th>
                            <th style={{ width: "20%" }}>Valor</th>
                            <th style={{ width: "30%" }}>Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.obs.items_historico_plano}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </MDBModalBody>
              </Dialog>

              <Alert
                cancelButtonText="Fechar"
                confirmButtonText="Continuar"
                isOpen={EmpresaStore.obs.open_calculadora}
                onConfirm={() => this.handleUpdatePlano()}
                onClose={() => this.onCloseSelectPlano()}
                canOutsideClickCancel={true}
                className="AlertUser"
                intent="primary"
              >
                <div style={{ display: 'ruby' }}>
                  <img className="iconSEFAZ" src="/images/calculadora.png" width="40px" />
                  <h2 className="titleSEFAZ">Selecione seu Plano</h2>
                </div>

                <CalculadoraPage />
              </Alert>

              <Alert
                confirmButtonText="Salvar"
                cancelButtonText="Cancelar"
                intent="primary"
                isOpen={PerfilStore.obs.open_user_dominio}
                onCancel={() => this.handleCancelUserDominio()}
                onConfirm={() => this.handleSaveUserDominio()}
                canOutsideClickCancel={true}
              >
                <h2 className="title-cert">Usuário Domínio</h2>
                <MDBRow>
                  <MDBCol>
                    <FormGroup label="Usuário Domínio"
                      labelInfo="(obrigatório)"
                    >
                      <InputGroup name='new-user-dominio' autoComplete='new-user-dominio' value={PerfilStore.obs.user_dominio} onChange={(e: any) => PerfilStore.obs.user_dominio = e.target.value} />
                    </FormGroup>
                  </MDBCol>

                  <MDBCol>
                    <FormGroup
                      label="Senha Domínio"
                      labelInfo="(obrigatório)"
                    >
                      <InputGroup
                        type="password"
                        onChange={(e: any) => PerfilStore.obs.password_dominio = e.target.value}
                        name='new-password-dominio'
                        autoComplete='new-password-dominio'
                      />
                    </FormGroup>
                  </MDBCol>

                </MDBRow>
                <MDBRow>
                  <MDBCol>
                    <FormGroup label="Usuário Folha"
                      labelInfo="(obrigatório)"
                    >
                      <InputGroup name='new-user-folha' autoComplete='new-user-folha' value={PerfilStore.obs.user_folha} onChange={(e: any) => PerfilStore.obs.user_folha = e.target.value} />
                    </FormGroup>
                  </MDBCol>
                  <MDBCol>
                    <FormGroup
                      label="Senha Folha"
                      labelInfo="(obrigatório)"
                    >
                      <InputGroup
                        type="password"
                        name='new-user-folha'
                        autoComplete='new-user-folha'
                        onChange={(e: any) => PerfilStore.obs.password_folha = e.target.value}
                      />
                    </FormGroup>
                  </MDBCol>
                </MDBRow>
              </Alert>

              <Dialog
                isOpen={PerfilStore.obs.formPlan}
                title="Editar Dados do Pagamento"
                onClose={() => PerfilStore.obs.formPlan = false}
                style={{ width: 800 }}
              >
                <div>
                  <Tabs
                    id="tabs"
                    className={"tabsCalculos"}
                    selectedTabId={this.obs.selectedTab}
                    onChange={(tabId) => this.obs.selectedTab = String(tabId)}
                  >
                    <Tab
                      id="forma_pagamento"
                      title="Forma Pagamento"
                      panel={<FormaPagamento ref={this.obs.trFormaPagamento} />}
                    />
                    <Tab
                      id="data_vencimento"
                      title="Data Vencimento"
                      panel={<DataVencimento ref={this.obs.trDataVencimento} />}
                    />
                  </Tabs>
                </div>
              </Dialog>

              <Alert
                confirmButtonText="Salvar"
                cancelButtonText="Cancelar"
                intent="primary"
                isOpen={this.obs.alterPassUser}
                onCancel={() => this.handleCancelAlterPass()}
                onConfirm={() => this.handleSendAlterPass()}
                canOutsideClickCancel={true}
              >
                <h2 className="title-cert">Editar Senha</h2>
                <FormGroup
                  label="Nova senha"
                  labelInfo="(obrigatório)"
                  helperText="Escolha uma nova senha. A senha deve ter pelo menos 6 caracteres."
                >
                  <InputGroup
                    name='new-password'
                    autoComplete='new-password'
                    value={this.obs.newPassword}
                    type="password"
                    onChange={(e: any) => this.obs.newPassword = e.target.value}
                  />
                </FormGroup>
              </Alert>
              <Alert
                confirmButtonText="Salvar"
                cancelButtonText="Cancelar"
                intent="primary"
                isOpen={this.obs.alterEmailIugu}
                onCancel={() => this.handleCancelAlterEmailIugu()}
                onConfirm={() => this.handleSendAlterEmailIugu()}
                canOutsideClickCancel={true}
              >
                <h2 className="title-cert">Editar E-mail Cobrança</h2>

                <FormGroup
                  label="Novo E-mail"
                  labelInfo="(obrigatório)"
                  helperText="Insira seu e-mail"
                >
                  <InputGroup
                    type="text"
                    name='new-email'
                    autoComplete='new-email'
                    onChange={(e: any) => this.obs.newEmail = e.target.value}
                  />
                </FormGroup>
              </Alert>

              <MDBRow>
                <MDBCol md="4">
                  <div className="bloco-perfil">
                    <div className="perfilUser">
                      {niveis_acesso &&
                        (
                          <MDBBtn
                            className="btnDefault btnAlterImage"
                            onClick={() => this.obs.changingImage = true}
                          >
                            Editar Imagem
                          </MDBBtn>
                        )}
                      {PerfilStore.obs.imagem != ""
                        ? (
                          <>
                            <MDBRow>
                              <MDBCol md="6" xs="12" className="offset-md-3">
                                <div
                                  className="imagem_perfil"
                                  style={{ backgroundImage: "url(data:image/jpge;base64," + PerfilStore.obs.imagem + ")" }}
                                >
                                </div>
                              </MDBCol>
                            </MDBRow>
                          </>
                        )
                        : (
                          <>
                            <MDBRow>
                              <MDBCol md="6" xs="12" className="offset-md-3">
                                <div
                                  className="imagem_perfil"
                                  style={{
                                    backgroundImage:
                                      "url(\"/images/perfil.png\")",
                                  }}
                                >
                                </div>
                              </MDBCol>
                            </MDBRow>
                          </>
                        )}
                      <h2>{AppStore.obs1.usuario.conta.nome}</h2>
                    </div>
                    <div className="dadosContaUser">
                      {niveis_acesso &&
                        (
                          <MDBBtn
                            className="btnDefault btnAlterSenha"
                            style={{ marginLeft: 0 }}
                            onClick={() => PerfilStore.obs.contaEdit = true}
                          >
                            Editar Dados da Conta
                          </MDBBtn>
                        )}
                      <p>
                        <span>Conta CNPJ:</span>
                        {formatCnpj(AppStore.obs1.usuario?.conta?.cnpj || "")}
                      </p>
                      <p>
                        <span>Nome do Usuário:</span>
                        {AppStore.obs1.usuario.nome_completo}
                      </p>
                      <p>
                        <span>E-mail:</span>
                        {AppStore.obs1.usuario.email}
                      </p>
                      <p>
                        <span>Senha:</span>
                        ********{" "}
                        <MDBBtn
                          className="btnDefault btnAlterSenha"
                          onClick={() => this.obs.changingPassword = true}
                        >
                          Editar Senha
                        </MDBBtn>
                      </p>
                      <p>
                        <span>Configurar Dupla Autenticação:</span>
                        <MDBBtn
                          className="btnDefault btnConfigurar"
                          onClick={() => this.handleOpenAuth2Fa()}
                        >
                          Configurar
                        </MDBBtn>
                      </p>
                    </div>
                  </div>
                  {niveis_acesso &&
                    (
                      <MDBRow>
                        <MDBCol md="12">
                          <div className="bloco-perfil">
                            <div className="dadosAssin">
                              <span className="descAssinPerfil">
                                <span className="priceAssinPerfil">
                                  <b>R$</b>{" "}
                                  {numeral(PerfilStore.obs.valortotal_assinatura)
                                    .format("0,0.00") ||
                                    numeral(PerfilStore.obs.totalPlano).format(
                                      "0,0.00",
                                    )}
                                </span>{" "}
                                <br />
                                <b>Plano:</b> Mensal <br />
                                {AppStore.obs1.usuario &&
                                  AppStore.obs1.usuario.conta.id_assinatura != "" &&
                                  (
                                    <>
                                      <b>Forma de Pagamento:</b>
                                      {AppStore.obs1.usuario && PerfilStore.obs.metodo_pagamento.includes("bank_slip")
                                        ? " Boleto Bancário"
                                        : " Cartão de Crédito"}
                                      <br />
                                      <b>Vencimento da Fatura:</b>
                                      {" " + PerfilStore.obs.expiraem_assinatura.split("-").reverse().join("/")}&nbsp;
                                      <AppIcon name="help" className="pulse-notification-pgdas" color="blue" style={{ cursor: "pointer" }} onClick={() => this.obs.open_ajuda = true} />
                                    </>
                                  )}

                                <br />
                                <b>Faturas pendentes:</b>&nbsp;
                                {PerfilStore.obs.boletos_pendentes.length > 0
                                  ? PerfilStore.obs.boletos_pendentes?.map(el => {
                                    return (
                                      <>
                                        <br />
                                        <a href={el.url}>
                                          Visualizar fatura {el.vencimento}
                                        </a>
                                      </>
                                    );
                                  })
                                  : "Nenhuma fatura em aberto"}
                                <br />
                                <b>E-mail Cobrança:</b>{" "}
                                {PerfilStore.obs.email_assinatura}{" "}
                                <MDBBtn
                                  color="default"
                                  rounded
                                  size="sm"
                                  onClick={() => this.obs.alterEmailIugu = true}
                                >
                                  <img
                                    className="imgIconsEditca"
                                    src="/images/edit.png"
                                    width={18}
                                  />
                                </MDBBtn>{" "}
                                <br />
                                <br />
                              </span>

                              <MDBBtn
                                className="btnDefault"
                                onClick={() => this.handleHistoricoPlano()}
                              >
                                Verificar Histórico de Faturas
                              </MDBBtn>
                              {!contaPermissao &&
                                (
                                  <MDBBtn
                                    className="btnDefault"
                                    onClick={() => PerfilStore.obs.formPlan = true}
                                  >
                                    Editar Dados de Pagamento
                                  </MDBBtn>
                                )}
                            </div>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    )}
                </MDBCol>

                {niveis_acesso &&
                  (
                    <MDBCol md="8">
                      <MDBRow>
                        <MDBCol md="12">
                          {!contaPermissao &&
                            (
                              <>
                                <MDBBtn
                                  className="btnDefault btnAlterImage"
                                  onClick={() => this.obs.createUser = true}
                                >
                                  Cadastrar Usuário
                                </MDBBtn>
                              </>
                            )}
                          <div className="bloco-perfil">
                            <h2 className="title">Usuários da Plataforma</h2>
                            <div className="TableDefault tablePerfil">
                              <HTMLTable
                                className="table table-hover dataTable"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Nome</th>
                                    <th>E-mail</th>
                                    <th>Senha</th>
                                    <th>Ações</th>
                                    <th></th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rows}
                                </tbody>
                              </HTMLTable>
                            </div>
                          </div>
                        </MDBCol>
                        <MDBCol md="12">
                          {!contaPermissao && rows_contador.length == 0 &&
                            (
                              <>
                                <MDBBtn
                                  className="btnDefault btnAlterImage"
                                  onClick={() => this.handleOpenContadores()}
                                >
                                  Cadastrar Contador
                                </MDBBtn>
                              </>
                            )}
                          <div className="bloco-perfil">
                            <h2 className="title">Contador da Plataforma</h2>
                            <div className="TableDefault tablePerfil">
                              <HTMLTable
                                className="table table-hover dataTable"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Nome</th>
                                    <th>E-mail</th>
                                    <th>CPF</th>
                                    <th>CRC</th>
                                    <th>CEP</th>
                                    <th>Ações</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rows_contador}
                                </tbody>
                              </HTMLTable>
                            </div>
                          </div>
                        </MDBCol>
                        {/* <MDBCol md="12">
                          {!contaPermissao && rows_user_dominio.length == 0 &&
                            <MDBBtn
                              className="btnDefault btnAlterImage"
                              onClick={() => this.handleCreateUserDominio()}
                            >
                              Cadastrar Usuário Domínio
                            </MDBBtn>
                          }
                          <div className="bloco-perfil">
                            <h2 className="title">Dados Domínio</h2>
                            <div className="TableDefault tablePerfil">
                              <HTMLTable
                                className="table table-hover dataTable"
                                style={{ width: "100%" }}
                              >
                                <thead>
                                  <tr>
                                    <th>Usuário Domínio</th>
                                    <th>Senha Domínio</th>
                                    <th>Usuário Folha</th>
                                    <th>Senha Folha</th>
                                    <th></th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rows_user_dominio}
                                </tbody>
                              </HTMLTable>
                            </div>
                          </div>
                        </MDBCol> */}
                        <MDBCol md="12" style={{ marginBottom: 80 }}>
                          <MDBBtn
                            className="btnDefault btnAlterImage"
                            onClick={() => this.viewValores()}
                          >
                            Verificar Alterações no Plano
                          </MDBBtn>

                          <div className="bloco-perfil">
                            <h2 className="title">Sua Assinatura</h2>
                            <MDBRow>
                              {itens}
                              {PerfilStore.obs.empresas_planos_personalizados.length > 0 &&
                                <MDBCol md="6">
                                  <div className="blocoAssin">
                                    <span className="descAssinPerfil">Plano <b>Personalizado</b></span>
                                    <span className="priceAssinPerfil"><b>Personalizado</b></span>
                                    <span className="periodoAssinPerfil">por empresa (mensal)</span>
                                    <span className="descAssinPerfil"></span>
                                    <br />
                                    <br />
                                    <span className="countAssinPerfil" onClick={() => this.obs.planBusiness = true}>
                                      {PerfilStore.obs.empresas_planos_personalizados.length <= 1
                                        ? PerfilStore.obs.empresas_planos_personalizados.length + " CNPJ"
                                        : PerfilStore.obs.empresas_planos_personalizados.length + " CNPJs"}
                                    </span>
                                  </div>
                                </MDBCol>
                              }
                            </MDBRow>
                          </div>
                        </MDBCol>
                      </MDBRow>
                    </MDBCol>
                  )}
              </MDBRow>

              <div style={{ marginTop: 5, marginBottom: 30 }} />

            </>
          )}
        {this.obs.changingPassword &&
          (
            <ChangePasswordDialog
              onClose={() => this.obs.changingPassword = false}
            />
          )}
        {this.obs.changingImage &&
          <ChangeImageDialog onClose={() => this.obs.changingImage = false} />}
        {this.obs.createUser &&
          <CreateUserDialog onClose={() => this.obs.createUser = false} />}
        {ContadorDialogStore.obs.isOpen_contador &&
          (
            <Dialog
              isOpen
              title="Adicionar Contador"
              onClose={() => ContadorDialogStore.obs.isOpen_contador = false}
            >
              <Tabs
                id="tabs"
                className={"tabsCalculos"}
                selectedTabId={this.obs.selectedTabContador}
                onChange={(tabId) => this.obs.selectedTabContador = String(tabId)}
              >
                <Tab
                  id="create_contador"
                  title="Contador"
                  panel={
                    <CreateContadorDialog
                      item={this.obs.item_contador}
                      onClose={() => ContadorDialogStore.obs.isOpen_contador = false}
                    />
                  }
                />
                <Tab
                  id="certificado_contador"
                  title="Certificado Contador"
                  panel={<CertificadoDialog />}
                />
              </Tabs>

              <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                  <Button text="Cancelar" onClick={() => ContadorDialogStore.obs.isOpen_contador = false} />
                  <Button
                    text="Salvar"
                    intent="primary"
                    onClick={() => this.handldeContador()}
                  />
                </div>
              </div>
            </Dialog>
          )}
        {this.obs.editUser && <EditUserDialog onClose={() => this.obs.editUser = false} />}

        <InfoModal open={this.obs.open_ajuda} onClose={() => this.obs.open_ajuda = false} texto_info={"Fatura será gerada 5 dias antes do vencimento."} />

      </div>
    );
  }

  renderNormal() {
    let userPermissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.permissao : "";
    let totalEmpresas = PerfilStore.obs.pagamentos.length;
    return (
      <>
        {this.renderData()}
      </>
    );
  }

  render() {
    return this.renderNormal();
  }
}
